"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FlagIconFactory.default;
  }
});
Object.defineProperty(exports, "CustomFlagIconFactory", {
  enumerable: true,
  get: function get() {
    return _FlagIconFactory.CustomFlagIconFactory;
  }
});
exports.functions = exports.types = void 0;

var _FlagIconFactory = _interopRequireWildcard(require("./FlagIcon/FlagIconFactory"));

var _types = _interopRequireWildcard(require("./types/flow"));

exports.types = _types;

var _functions = _interopRequireWildcard(require("./functions"));

exports.functions = _functions;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/index.js
// module id = 343
// module chunks = 168707334958949